<template>
  <span>
    <group-content></group-content>
  </span>
</template>

<script>
import GroupContent from "@/components/Team/GroupContent";
export default {
  name: "Group",
  components: {
    GroupContent
  }
};
</script>